import { runCordovaPluginCall } from '@helpers/cordovaBridge';
import { logger } from '@utils';

declare const window: any;

interface ILaunchReviewPlugin {
  isRatingSupported: () => boolean;
  rating: (
    success?: (status: string) => void,
    error?: (error: any) => void
  ) => void;
}

let requestedThisSession = false;

export function requestNativeStoreReview(): boolean {
  if (requestedThisSession || typeof window === "undefined" || !window.cordova) {
    return false;
  }

  const launchReview: ILaunchReviewPlugin | undefined = window.LaunchReview;
  if (!launchReview || typeof launchReview.rating !== "function"
    || typeof launchReview.isRatingSupported !== "function"
    || !launchReview.isRatingSupported()) {
    return false;
  }

  try {
    const didStart = runCordovaPluginCall("LaunchReview.rating", () => {
      launchReview.rating(
        undefined,
        (error: any) => logger.info("Could not request native store review", error)
      );
      return true;
    }, false) === true;

    if (didStart) {
      requestedThisSession = true;
    }
    return didStart;
  } catch (error) {
    logger.info("Could not request native store review", error);
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/services/rating/nativeReview.ts